import { Box, Button, IconButton, Tab, Typography } from "@mui/material"
import { MRT_ColumnDef, MRT_Row } from "material-react-table"
import React, { useEffect, useState } from "react"
import EditIcon from "../../../assets/icons/edit.svg"
import { jsPDF } from "jspdf" //or use your library of choice here
import autoTable from "jspdf-autotable"
import {
  HuddleHeader,
  NavigationAssistant,
  StyledTabsList,
  TableWrapperPaper,
  TableWrapperPaperOld,
} from "./Atom"
import {
  ActiveOpportuntiesTableConfig,
  DailyProductionGoalTableConfig,
  HuddleSummaryFutureStatic,
  HuddleSummaryKeyMetricsTableConfigStatic,
  HuddleSummaryYesterdayTableConfig,
  ProviderSummaryFixedTableConfig,
  ProviderSummaryTableConfigStatic,
  TodayAuditTableConfig,
  TodaysTableConfig,
  YesterdayAuditTableConfig,
  YesterdayTableConfig,
} from "./tableConfig"
import { ConfirmModal } from "../../components/Tabs/ResourceBudgetTabs/Atom"
import {
  fetchGroupsHandler,
  fetchHuddleActiveOpportunitiesData,
  fetchHuddleSummaryData,
  fetchHuddleSummaryKeyMetricsData,
  fetchHuddleTodayAuditData,
  fetchHuddleTomorrowAuditData,
  fetchHuddleYesterdayAuditData,
  fetchOfficesHandler,
  fetchProviderSummaryData,
  fetchRegionsHandler,
  updateHuddleHours,
} from "./apiUtils"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import {
  assignTableId,
  csvConfig,
  extractTableData,
  getTokenLocal,
  transformDataCSV,
} from "../../../helper/utils"
import {
  setHuddleActiveOpportuntiesData,
  setHuddleData,
  setHuddleSummaryData,
  setHuddleSummaryKeyMetricsData,
  setHuddleTodayAuditData,
  setHuddleTomorrowAuditData,
  setHuddleYesterdayAuditData,
  setLastUpdatedDate,
  setProviderSummaryData,
  setSelectedHuddleTab,
  setUpdatedHuddleHours,
} from "../../redux/slices/huddleSlice"
import { useNavigate } from "react-router-dom"
import { setLoading, setOpenSidebar } from "../../redux/slices/appSlice"
import {
  setMaevaGroups,
  setMaevaPractices,
  setMaevaRegions,
} from "../../redux/slices/metricSlice"
import { useSelector } from "react-redux"
import { permissions } from "../../../config/constants"
import { HuddleTabs } from "../../components/Tabs"
import { DailyProductionGoalTable } from "../../components/Table/HuddleTable/DailyProductionGoalTable"
import { ActiveOpportunitiesTable } from "../../components/Table/HuddleTable/ActiveOpportunitiesTable"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { AuditTable } from "../../components/Table/AuditTable/Index"
import { HuddleSummaryYesterdayTable } from "../../components/Table/HuddleTable/HuddleSummaryYesterdayTable"
import { HuddleSummaryFutureTable } from "../../components/Table/HuddleTable/HuddleSummaryFutureTable"
import { HuddleSummaryKeyMetricsTable } from "../../components/Table/HuddleTable/HuddleSummaryKeyMetricsTable"
import { ProviderSummaryTable } from "../../components/Table/HuddleTable/ProviderSummaryTable"
import { amountFormatter } from "../../components/Table/PNLReportingTable/tableConfigs"
import { formatNumber, roundUp } from "../../../helper/utils/formatting"
import { colors } from "../../../styles/commonStyles"
import { ProviderSummaryFixTable } from "../../components/Table/HuddleTable/ProviderSummaryFixTable"
import moment from "moment"
import { setComplianceData } from "../../redux/slices/complianceSlice"
import { fetchComplianceData } from "../Compliance/apiUtils"
import { mkConfig, generateCsv, download } from "export-to-csv"

const Huddle = () => {
  const today = moment().format("DD MMM, YYYY")
  const priorDay = moment().subtract(1, "day").format("DD MMM, YYYY")

  const state = useAppSelector((state) => state.huddle)

  const currentLoggedInUser = useSelector(
    (state: any) => state.admin.currentUser,
  )

  const token = getTokenLocal()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  dispatch(setOpenSidebar(false))
  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })
  const perms = useAppSelector((state) => state.rolesAndPerms.userPerms)

  const downloadSelection = useSelector((state: any) => {
    return state.app.exportPdfCsvSelection
  })
  const maevaSelectedGroupsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll
  })
  const groups = useAppSelector((state: any) => state.metric?.maevaGroups)
  const selectedHuddleGroup = maevaSelectedGroupsNoAll?.[0]
  const maevaSelectedRegionsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll
  })
  const selectedHuddleRegion = maevaSelectedRegionsNoAll?.[0]
  const maevaSelectedPracticesNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedPracticesNoAll
  })
  const selectedHuddleOffice = maevaSelectedPracticesNoAll?.[0]
  const { huddleData } = state
  const selectedHuddleTab = useSelector((state: any) => {
    return state.huddle.selectedHuddleTab
  })
  const huddleSummaryData = useSelector((state: any) => {
    return state.huddle.huddleSummaryData
  })
  const huddleSummaryKeyMetricsData = useSelector((state: any) => {
    return state.huddle.huddleSummaryKeyMetricsData
  })
  const huddleActiveOpportuntiesData = useSelector((state: any) => {
    return state.huddle.huddleActiveOpportuntiesData
  })
  const providerSummaryData = useSelector((state: any) => {
    return state.huddle.providerSummaryData
  })
  const huddleHours = useSelector((state: any) => {
    return state.huddle.huddleHours
  })
  const huddleTodayAuditData = useSelector((state: any) => {
    return state.huddle.huddleTodayAuditData
  })
  const huddleYesterdayAuditData = useSelector((state: any) => {
    return state.huddle.huddleYesterdayAuditData
  })
  const huddleTomorrowAuditData = useSelector((state: any) => {
    return state.huddle.huddleTomorrowAuditData
  })
  const huddleSummaryTodayRows = useSelector((state: any) => {
    return state.huddle.huddleSummaryTodayRows
  })
  const huddleSummaryYesterdayRows = useSelector((state: any) => {
    return state.huddle.huddleSummaryYesterdayRows
  })
  const huddleSummaryFutureRows = useSelector((state: any) => {
    return state.huddle.huddleSummaryFutureRows
  })
  const huddleSummaryKeyMetricsRows = useSelector((state: any) => {
    return state.huddle.huddleSummaryKeyMetricsRows
  })
  const huddleActiveOpportunitiesRows = useSelector((state: any) => {
    return state.huddle.huddleActiveOpportunitiesRows
  })
  const providerSummaryRows = useSelector((state: any) => {
    return state.huddle.providerSummaryRows
  })

  const complianceState = useAppSelector((state) => state.compliance)
  const { complianceData } = complianceState
  const [valueTab, setValueTab] = useState("1")

  const [editState, setEditState] = React.useState({
    provider: "",
    index: null,
    providerSK: null,
    value: 0,
    showDialog: false,
    loading: false,
    transaction_date: null,
  })

  const openDialog = (changeValue: number, row: any) => {
    const value = changeValue.toFixed(2)
    if (value === row?.original?.hours) {
      return
    }
    setEditState({
      loading: false,
      value: changeValue,
      showDialog: true,
      index: row.index,
      provider: row?.original?.provider_name,
      providerSK: row?.original?.provider_sk,
      transaction_date: row?.original?.yesterday?.y_date,
    })
  }

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValueTab: string,
  ) => {
    setValueTab(newValueTab)
  }
  const dialogLoading = React.useCallback((loadVal: boolean) => {
    loadVal
      ? setEditState((prev) => ({ ...prev, loading: true }))
      : setEditState((prev) => ({ ...prev, loading: false, showDialog: false }))
  }, [])
  const closeDialog = () => {
    setEditState((prev) => ({ ...prev, showDialog: false }))
  }
  const confirmActionHandler = () => {
    setEditState((prev) => ({ ...prev, loading: true }))
    updateHuddleHours({
      token,
      dispatch: () => {
        dispatch(setUpdatedHuddleHours(editState.value))
      },
      navigate,
      selectedHuddleOffice,
      loading: dialogLoading,
      selectedProvider: editState.providerSK,
      huddleData,
      newHours: editState.value,
      transactionDate: editState.transaction_date,
    })
  }
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(() => {
    const cols: MRT_ColumnDef<any>[] = [
      {
        header: "Adjustment Type",
        accessorKey: "type",
        muiTableBodyCellProps: { sx: { fontWeight: "bold" } },
      },
    ]
    const dynamicCols = complianceData?.column_headers?.map(
      (header: string) => {
        return {
          header: header?.replaceAll(",", " "),
          accessorKey: header,
          Cell: amountFormatter,
        } as MRT_ColumnDef<any>
      },
    )
    return cols.concat(dynamicCols || [])
  }, [complianceData])

  const data = React.useMemo(() => {
    return Object.keys(complianceData?.data || [])?.map((type: string) => {
      let datum: any = {
        type,
      }
      complianceData?.data?.[type]?.forEach((item: any) => {
        datum[item?.date] = item?.amount || 0.0
      })
      return datum
    })
  }, [complianceData])
  const dailyProductionGoalColumns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        id: "1",
        header: "Metric Name",
        accessorKey: "metric_name",
        enableEditing: false,
        enableSorting: false,
        muiTableBodyCellProps: {
          align: "left",
          sx: {
            height: "48px",
            border: "0.5px solid #E4E4E4",
            boxShadow: "#00000022 1.95px 0px 2.6px",
            color: "black",
            fontWeight: "600",
          },
        },
      },
      {
        id: "2",
        accessorKey: "mtd_budget",
        header: "MTD Budget",
        enableEditing: false,
        Cell: amountFormatter,
      },
      {
        id: "3",
        accessorKey: "mtd_actual",
        header: "MTD Actual",
        enableEditing: false,
        Cell: amountFormatter,
      },
      {
        id: "4",
        accessorKey: "mtd_variance",
        header: "Variance",
        enableEditing: false,

        Cell: (cellProps: any) => <Box>{amountFormatter(cellProps)}</Box>,
        muiTableBodyCellProps: ({ cell }: any) => ({
          sx: {
            padding: "0px 1%",
            "& div": {
              display: "flex",
              margin: "auto",
              justifyContent: "center",
              padding: "3%",

              border:
                cell.getValue() > 0
                  ? "1px solid #FFFFFF"
                  : cell.getValue() < 0
                  ? "1px solid #FFFFFF"
                  : null,
              backgroundColor:
                cell.getValue() > 0
                  ? colors.primaryGreen
                  : cell.getValue() < 0
                  ? colors.primaryRed
                  : "#FFFFFF",
              color:
                cell.getValue() == 0
                  ? colors.primaryBlack
                  : colors.primaryWhite,
            },
          },
        }),
      },
      {
        id: "5",
        accessorKey: "month_end_goal",
        header: "Month End Goal",
        enableEditing: false,
        Cell: amountFormatter,
        muiTableBodyCellProps: () => ({
          sx: {
            borderLeft: "1px solid #E4E4E4",
          },
        }),
      },
      {
        id: "6",
        accessorKey: "projected_amount",
        header: "Projected Amount",
        enableEditing: false,
        Cell: amountFormatter,
      },
      {
        id: "7",
        accessorKey: "projected_variance",
        header: "Projected Variance",
        enableEditing: false,
        Cell: (cellProps: any) => <Box>{amountFormatter(cellProps)}</Box>,
        muiTableBodyCellProps: ({ cell }: any) => ({
          sx: {
            padding: "0px 4%",
            "& div": {
              display: "flex",
              margin: "auto",
              justifyContent: "center",
              padding: "3%",

              border:
                cell.getValue() > 0
                  ? "1px solid #FFFFFF"
                  : cell.getValue() < 0
                  ? "1px solid #FFFFFF"
                  : null,
              backgroundColor:
                cell.getValue() > 0
                  ? colors.primaryGreen
                  : cell.getValue() < 0
                  ? colors.primaryRed
                  : "#FFFFFF",
              color:
                cell.getValue() == 0
                  ? colors.primaryBlack
                  : colors.primaryWhite,
            },
          },
        }),
      },
      {
        id: "8",
        accessorKey: "adjusted_daily_goal",
        header: "Adjusted Daily Goal",
        enableEditing: false,
        Cell: (cellProps: any) => <Box>{amountFormatter(cellProps)}</Box>,
        muiTableBodyCellProps: ({ cell, row }: any) => {
          const getBgColor = (val: any) => {
            if (parseFloat(cell.getValue()) > parseFloat(val)) {
              return colors.primaryRed
            } else {
              return colors.primaryGreen
            }
          }

          return {
            sx: {
              padding: "0px 4%",
              "& div": {
                display: "flex",
                margin: "auto",
                justifyContent: "center",
                padding: "3%",

                border:
                  cell.getValue() > 0
                    ? "1px solid #FFFFFF"
                    : cell.getValue() < 0
                    ? "1px solid #FFFFFF"
                    : null,
                backgroundColor:
                  row?.original?.metric_name == "Production"
                    ? getBgColor(huddleSummaryData?.dailyProductionGoalValue)
                    : row?.original?.metric_name == "Collection"
                    ? getBgColor(huddleSummaryData?.dailyCollectionGoalValue)
                    : colors.primaryWhite,
                color:
                  cell.getValue() === "0"
                    ? colors.primaryBlack
                    : colors.primaryWhite,
              },
            },
          }
        },
      },
    ],
    [huddleSummaryData],
  )
  const huddleSummaryYesterdayColumns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => HuddleSummaryYesterdayTableConfig,
    [],
  )

  let HuddleSummaryFutureDynamic: MRT_ColumnDef<any>[] =
    huddleSummaryData?.huddleSummaryFutureDateColumns
      ?.map(
        (column: any, index: number) => {
          const columnId = column
          const columnHeader = column
          const columnDate = moment(columnHeader, "DD MMM, YYYY")
          const isToday =
            columnDate.format("DD MMM, YYYY") ===
            moment().format("DD MMM, YYYY")

          return {
            // header: columnHeader,
            header: isToday ? "Today" : columnHeader,
            id: columnId,
            isToday: isToday,
            columnDate: columnDate,
            accessorKey: `${column}_value`,
            Cell: (cellProps: any) => <Box>{amountFormatter(cellProps)}</Box>,
            muiTableBodyCellProps: ({ cell }: any) => {
              return {
                sx: {
                  padding: "0px 2%",
                  "& div": {
                    display: "flex",
                    margin: "auto",
                    justifyContent: "center",
                    padding: "2% 1%",

                    border:
                      cell.row.original.metric_name == "Difference"
                        ? cell.getValue() > 0
                          ? "1px solid #FFFFFF"
                          : cell.getValue() < 0
                          ? "1px solid #FFFFFF"
                          : "1px solid #E4E4E4"
                        : "none",
                    backgroundColor:
                      cell.row.original.metric_name == "Difference"
                        ? cell.getValue() > 0
                          ? colors.primaryGreen
                          : cell.getValue() < 0
                          ? colors.primaryRed
                          : "#FFFFFF"
                        : "#FFFFFF",
                    color:
                      cell.row.original.metric_name == "Difference"
                        ? cell.getValue() == 0
                          ? colors.primaryBlack
                          : colors.primaryWhite
                        : colors.primaryBlack,
                  },
                },
              }
            },
          }
        },
        [huddleSummaryData],
      )
      .sort((a: any, b: any) => {
        // First, put "Today" at the beginning
        if (a.isToday && !b.isToday) return -1
        if (!a.isToday && b.isToday) return 1

        // If both are not "Today", sort chronologically
        if (!a.isToday && !b.isToday) {
          return a.columnDate.diff(b.columnDate)
        }

        // If both are "Today" (shouldn't happen), maintain original order
        return 0
      }) || []

  const HuddleSummaryFutureTableConfig: MRT_ColumnDef<any>[] =
    HuddleSummaryFutureStatic.concat(HuddleSummaryFutureDynamic)

  const huddleSummaryFutureColumns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => HuddleSummaryFutureTableConfig,
    [huddleSummaryData],
  )

  let HuddleSummaryKeyMetricsTableConfigDynamic: MRT_ColumnDef<any>[] =
    huddleSummaryKeyMetricsData?.[0]?.date_list
      ?.map(
        (column: any, index: number) => {
          const columnId = `${index}_${column?.date}`
          // const columnId = index
          const columnHeader = column?.date
          const formattedColumnDate = moment(
            columnHeader,
            "DD MMM, YYYY",
          ).format("DD MMM, YYYY")
          const today = moment().format("DD MMM, YYYY")

          // Step 1: Get the latest date before today
          const lastDateBeforeToday =
            huddleSummaryKeyMetricsData?.[0]?.date_list
              ?.map((col: any) => moment(col?.date, "DD MMM, YYYY"))
              .filter((date: any) => date.isBefore(moment(), "day")) // only before today
              .sort((a: any, b: any) => b.diff(a))?.[0] // latest before today

          const formattedLastDate = lastDateBeforeToday?.format("DD MMM, YYYY")
          // const priorDay = moment().subtract(1, "day").format("DD MMM, YYYY")
          return {
            header:
              formattedColumnDate === today
                ? "Today"
                : formattedColumnDate === formattedLastDate
                ? "Prior Day"
                : columnHeader,
            id: columnId,
            order:
              formattedColumnDate === formattedLastDate
                ? 0
                : formattedColumnDate === today
                ? 1
                : 2, // Assign order values
            accessorKey: `${column?.date}_value`,
            Cell: ({ renderedCellValue }: any) =>
              `${
                renderedCellValue
                  ? roundUp(renderedCellValue, column?.key_metric_datatype)
                  : ""
              }`,
            maxSize: 80,
          }
        },
        [huddleSummaryKeyMetricsData],
      )
      .sort((a: any, b: any) => a.order - b.order) || []

  const HuddleSummaryKeyMetricsTableConfig: MRT_ColumnDef<any>[] =
    HuddleSummaryKeyMetricsTableConfigStatic.concat(
      HuddleSummaryKeyMetricsTableConfigDynamic,
    )

  const huddleSummaryKeyMetricColumns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => HuddleSummaryKeyMetricsTableConfig,
    [huddleSummaryKeyMetricsData],
  )
  const activeOpportuntiesColumns: any = React.useMemo<MRT_ColumnDef<any>[]>(
    () => ActiveOpportuntiesTableConfig,
    [],
  )

  let ProviderSummaryTableDynamic: MRT_ColumnDef<any>[] =
    providerSummaryData?.[0]?.future?.date_list?.map(
      (column: any, index: number) => {
        const columnId = `${column?.date}_${column?.variance}`
        const columnHeader = column?.date

        return {
          header: columnHeader,
          id: columnId,
          accessorKey: `${column?.date}_value`,
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue ? (
              <Box>
                ${" "}
                {parseInt(renderedCellValue || "0").toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </Box>
            ) : (
              <Box>$ {renderedCellValue}</Box>
            ),
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
          muiTableBodyCellProps: ({ cell }: any) => ({
            sx: {
              padding: "0px 1%",
              border: "1px solid #E4E4E4",
              "& div": {
                display: "flex",
                margin: "auto",
                justifyContent: "center",
                padding: "3% 5%",
                border:
                  cell.getValue() > 0
                    ? "1px solid #FFFFFF"
                    : cell.getValue() < 0
                    ? "1px solid #FFFFFF"
                    : null,
                backgroundColor:
                  cell.getValue() > 0
                    ? colors.primaryGreen
                    : cell.getValue() < 0
                    ? colors.primaryRed
                    : "#FFFFFF",
                color:
                  cell.getValue() == 0
                    ? colors.primaryBlack
                    : colors.primaryWhite,
              },
            },
          }),
        }
      },
      [providerSummaryData],
    ) || []

  // const VarianceColumns = [
  //   {
  //     id: 'variance', //id used to define `group` column
  //     header: 'Variance (Next 5 Days)',
  //     columns: ProviderSummaryTableDynamic,
  //     muiTableHeadCellProps: {
  //       sx: {
  //         backgroundColor: "#FFFFFF",
  //         borderRight: "1px solid #000000"
  //       }
  //     },
  //   }
  // ]
  const ProviderSummaryTableConfigStatic: MRT_ColumnDef<any>[] = [
    {
      id: "provider",
      header: "",
      muiTableHeadCellProps: {
        sx: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #000000",
          // zIndex: "10"
        },
      },
      columns: [
        {
          header: "Provider",
          accessorKey: "provider_name",
          enableEditing: false,
          enableSorting: false,
          muiTableBodyCellProps: {
            align: "left",
            sx: {
              height: "48px",
              border: "0.5px solid #E4E4E4",
              boxShadow: "#00000022 1.95px 0px 2.6px",
              color: "black",
              fontWeight: "600",
            },
          },
        },
      ],
    },
    {
      id: "yesterday", //id used to define `group` column
      header: "Prior Day",
      muiTableHeadCellProps: {
        sx: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #000000",
        },
      },
      columns: [
        {
          accessorKey: "yesterday.y_hourly_goal",
          header: "Hourly Goal",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue
              ? `$ ${parseInt(renderedCellValue || "0").toLocaleString()}`
              : renderedCellValue,
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
        },
        {
          accessorKey: "yesterday.y_hours",
          header: "Hours",
          enableEditing: (row: any) => {
            return row?.original?.yesterday?.y_hours == null ||
              !allPerms.includes(permissions?.EDIT_YESTERDAY_HOURS)
              ? false
              : true
          },
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
          Cell: ({ renderedCellValue, table, cell }: any) => {
            const editingEnabled = table?.options?.enableEditing
            return (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: editingEnabled ? "space-between" : "center",
                  alignItems: "center",
                }}
              >
                <Box sx={{ flex: 1 }}></Box>
                <Box sx={{ flex: 1 }}>{renderedCellValue}</Box>
                {editingEnabled && cell.getValue() && (
                  <Box sx={{ flex: 1 }}>
                    <IconButton
                      disableTouchRipple
                      onClick={() => {
                        table.setEditingCell(cell)
                      }}
                    >
                      <img
                        src={EditIcon}
                        height={"12px"}
                        alt="edit hours"
                        style={{ cursor: "pointer" }}
                      />
                    </IconButton>
                  </Box>
                )}
              </Box>
            )
          },
        },
        {
          accessorKey: "yesterday.y_daily_prod_goal",
          header: "Daily Prod Goal",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue
              ? `$ ${parseInt(renderedCellValue || "0").toLocaleString()}`
              : renderedCellValue,
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
        },
        {
          accessorKey: "yesterday.y_actual_produced",
          header: "Actual Prod",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue
              ? `$ ${parseInt(renderedCellValue || "0").toLocaleString()}`
              : renderedCellValue,
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
        },
        {
          accessorKey: "yesterday.y_variance",
          header: "Variance",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue ? (
              <div>$ {parseInt(renderedCellValue || "0").toLocaleString()}</div>
            ) : (
              <div>$ {renderedCellValue}</div>
            ),
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
          muiTableBodyCellProps: ({ cell }: any) => ({
            sx: {
              padding: "0px 1%",
              border: "1px solid #E4E4E4",
              "& div": {
                display: "flex",
                margin: "auto",
                justifyContent: "center",
                padding: "3% 5%",

                border:
                  cell.getValue() > 0
                    ? "1px solid #FFFFFF"
                    : cell.getValue() < 0
                    ? "1px solid #FFFFFF"
                    : null,
                backgroundColor:
                  cell.getValue() > 0
                    ? colors.primaryGreen
                    : cell.getValue() < 0
                    ? colors.primaryRed
                    : "#FFFFFF",
                color:
                  cell.getValue() == 0
                    ? colors.primaryBlack
                    : colors.primaryWhite,
              },
            },
          }),
        },
      ],
    },
    {
      id: "today", //id used to define `group` column
      header: "Today",
      muiTableHeadCellProps: {
        sx: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #000000",
        },
      },
      columns: [
        {
          accessorKey: "today.t_daily_prod_goal",
          header: "Daily Prod Goal",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue
              ? `$ ${parseInt(renderedCellValue || "0").toLocaleString()}`
              : renderedCellValue,
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
        },
        {
          accessorKey: "today.t_scheduled_production",
          header: "Sch Prod",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue
              ? `$ ${parseInt(renderedCellValue || "0").toLocaleString()}`
              : renderedCellValue,
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />
        },
        {
          accessorKey: "today.t_variance",
          header: "Variance",
          enableEditing: false,
          Cell: ({ renderedCellValue }: any) =>
            renderedCellValue ? (
              <div>$ {parseInt(renderedCellValue || "0").toLocaleString()}</div>
            ) : (
              <div>$ {renderedCellValue}</div>
            ),
          // Header: ({ header, column }: any) => <HuddleProviderSummaryHeader header={header} column={column} />,
          muiTableBodyCellProps: ({ cell }: any) => ({
            sx: {
              padding: "0px 1%",
              border: "1px solid #E4E4E4",
              "& div": {
                display: "flex",
                margin: "auto",
                justifyContent: "center",
                padding: "3% 5%",

                border:
                  cell.getValue() > 0
                    ? "1px solid #FFFFFF"
                    : cell.getValue() < 0
                    ? "1px solid #FFFFFF"
                    : "1px solid #FFFFFF",
                backgroundColor:
                  cell.getValue() > 0
                    ? colors.primaryGreen
                    : cell.getValue() < 0
                    ? colors.primaryRed
                    : "#FFFFFF",
                color:
                  cell.getValue() == 0
                    ? colors.primaryBlack
                    : colors.primaryWhite,
              },
            },
          }),
        },
      ],
    },
    {
      id: "variance", //id used to define `group` column
      header: "Variance (Next 5 Days)",
      columns: ProviderSummaryTableDynamic,
      muiTableHeadCellProps: {
        sx: {
          backgroundColor: "#FFFFFF",
          borderRight: "1px solid #000000",
        },
      },
    },
  ]

  const ProviderSummaryTableConfig: MRT_ColumnDef<any>[] =
    ProviderSummaryTableConfigStatic
  // const ProviderSummaryTableConfig: MRT_ColumnDef<any>[] = ProviderSummaryTableConfigStatic.concat(VarianceColumns)

  const providerSummaryFixedColumns: any = React.useMemo<MRT_ColumnDef<any>[]>(
    () => ProviderSummaryFixedTableConfig,
    [providerSummaryData],
  )
  const providerSummaryColumns: any = React.useMemo<MRT_ColumnDef<any>[]>(
    () => ProviderSummaryTableConfig,
    [providerSummaryData],
  )
  const todayAuditColumns: any = React.useMemo<MRT_ColumnDef<any>[]>(
    () => TodayAuditTableConfig,
    [],
  )
  const yesterdayAuditColumns: any = React.useMemo<MRT_ColumnDef<any>[]>(
    () => YesterdayAuditTableConfig,
    [],
  )
  const loading = React.useCallback((loadVal: boolean) => {
    dispatch(setLoading(loadVal))
  }, [])

  React.useEffect(() => {
    fetchGroupsHandler({
      token,
      dispatch: (payload: any) => {
        dispatch(setMaevaGroups(payload))
      },
      navigate,
      loading,
    })
  }, [])

  React.useEffect(() => {
    if (selectedHuddleGroup) {
      fetchRegionsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaRegions(payload))
        },
        navigate,
        group: selectedHuddleGroup,
        loading,
      })
    }
  }, [maevaSelectedGroupsNoAll])
  React.useEffect(() => {
    if (selectedHuddleRegion) {
      fetchOfficesHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaPractices(payload))
        },
        navigate,
        loading,
        group: selectedHuddleGroup,
        region: selectedHuddleRegion,
      })
    }
  }, [maevaSelectedRegionsNoAll])
  // React.useEffect(() => {
  //   if (selectedHuddleOffice) {
  //     fetchHuddleData({
  //       token,
  //       dispatch: (payload: any) => {
  //         dispatch(setHuddleData(payload))
  //       },
  //       navigate,
  //       loading,
  //       office: selectedHuddleOffice,
  //     })
  //   }
  // }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleSummaryKeyMetricsData({
        token,
        dispatch: (payload: any) => {
          let customPayload: any = []

          payload?.forEach((keyMetric: any) => {
            let localObject = { ...keyMetric }

            keyMetric?.date_list?.forEach((ob: any) => {
              localObject[`${ob.date}_value`] = ob.key_metric_value
            })

            customPayload.push(localObject)
          })

          dispatch(setHuddleSummaryKeyMetricsData(customPayload))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleActiveOpportunitiesData({
        token,
        dispatch: (payload: any) => {
          dispatch(setHuddleActiveOpportuntiesData(payload))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchProviderSummaryData({
        token,
        dispatch: (payload: any) => {
          let providerSummaryTableData: any = []

          payload?.forEach((provider: any) => {
            let localObject = { ...provider }

            provider?.future?.date_list?.forEach((ob: any) => {
              localObject[`${ob.date}_value`] = ob.variance
            })

            providerSummaryTableData.push(localObject)
          })

          dispatch(setProviderSummaryData(providerSummaryTableData))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll, huddleHours])
  React.useEffect(() => {
    if (maevaSelectedPracticesNoAll && maevaSelectedPracticesNoAll[0]) {
      fetchComplianceData({
        token,
        dispatch: (payload: any) => {
          dispatch(setComplianceData(payload))
        },
        navigate,
        loading,
        office: maevaSelectedPracticesNoAll[0],
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleTodayAuditData({
        token,
        dispatch: (payload: any) => {
          dispatch(setHuddleTodayAuditData(payload))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleYesterdayAuditData({
        token,
        dispatch: (payload: any) => {
          dispatch(setHuddleYesterdayAuditData(payload))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleTomorrowAuditData({
        token,
        dispatch: (payload: any) => {
          dispatch(setHuddleTomorrowAuditData(payload))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  React.useEffect(() => {
    if (selectedHuddleOffice) {
      fetchHuddleSummaryData({
        token,
        dispatch: (payload: any) => {
          let huddleSummaryTodayTableData = []

          const productionToday = {
            ...payload?.today?.production,
            metric_name: "Production",
          }
          const collectionToday = {
            ...payload?.today?.collection,
            metric_name: "Collections(Payments)",
          }

          huddleSummaryTodayTableData.push(productionToday)
          huddleSummaryTodayTableData.push(collectionToday)

          let huddleSummaryYesterdayTableData = []

          const productionYesterday = {
            ...payload?.yesterday?.production,
            metric_name: "Production",
          }
          const collectionYesterday = {
            ...payload?.yesterday?.collection,
            metric_name: "Collections(Payments)",
          }

          huddleSummaryYesterdayTableData.push(productionYesterday)
          huddleSummaryYesterdayTableData.push(collectionYesterday)

          let huddleSummaryFutureTableData: any = []
          let huddleSummaryFutureDateColumns: any = []

          const budgetProduction: any = { metric_name: "Production Goal" }

          payload?.future?.budget_production.forEach((goal: any) => {
            huddleSummaryFutureDateColumns.push(goal?.date)
            budgetProduction[`${goal?.date}_value`] = goal.budget_production
          })

          const scheduledProductionFuture: any = {
            metric_name: "Scheduled Production",
          }

          payload?.future?.scheduled_production.forEach((goal: any) => {
            scheduledProductionFuture[`${goal.date}_value`] =
              goal.scheduled_production
          })

          const differenceFuture: any = { metric_name: "Difference" }
          payload?.future?.difference.forEach((goal: any) => {
            differenceFuture[`${goal.date}_value`] = goal.difference
          })
          huddleSummaryFutureTableData.push(scheduledProductionFuture)
          huddleSummaryFutureTableData.push(budgetProduction)
          huddleSummaryFutureTableData.push(differenceFuture)
          const dailyProductionGoalValue = payload.yesterday.production.goal
          const dailyCollectionGoalValue = payload.yesterday.collection.goal

          dispatch(
            setHuddleSummaryData({
              dailyProductionGoalValue: dailyProductionGoalValue,
              dailyCollectionGoalValue: dailyCollectionGoalValue,
              huddleSummaryTodayTableData: huddleSummaryTodayTableData,
              huddleSummaryYesterdayTableData: huddleSummaryYesterdayTableData,
              huddleSummaryFutureTableData: huddleSummaryFutureTableData,
              huddleSummaryFutureDateColumns: huddleSummaryFutureDateColumns,
            }),
          )
          dispatch(setLastUpdatedDate(payload?.last_updated))
        },
        navigate,
        loading,
        office: selectedHuddleOffice,
      })
    }
  }, [maevaSelectedPracticesNoAll])
  const navigationData = React.useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: maevaSelectedGroupsNoAll?.length ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: maevaSelectedRegionsNoAll?.length ? true : false,
      },
      {
        label: "Select a office to proceed",
        value: maevaSelectedPracticesNoAll?.length ? true : false,
      },
    ],
    [
      maevaSelectedGroupsNoAll,
      maevaSelectedRegionsNoAll,
      maevaSelectedPracticesNoAll,
    ],
  )

  const addHeaders = (doc: any, heading: string) => {
    doc.text(heading, doc.internal.pageSize.width / 2, 10, {
      align: "center",
    })

    const group: string = `Group - ${maevaSelectedGroupsNoAll[0]?.group_name}`
    const region: string = `Region - ${maevaSelectedRegionsNoAll[0]?.label}`
    const practice: string = `Practice - ${maevaSelectedPracticesNoAll[0]?.name}`
    const exportedBy: string = `Exported By - ${currentLoggedInUser?.first_name} ${currentLoggedInUser?.last_name}`
    const exportedAt: string = `Exported At - ${moment().format(
      "MM DD YYYY, h:mm a",
    )}`

    doc.setFont("Courier")
    doc.setFontSize(8)

    doc.text(
      `${group} | ${region} | ${practice}`,
      doc.internal.pageSize.width / 2,
      18,
      {
        align: "center",
      },
    )
    doc.text(
      `${exportedBy} | ${exportedAt}`,
      doc.internal.pageSize.width / 2,
      26,
      {
        align: "center",
      },
    )
  }

  const addFooters = (doc: any) => {
    const pageCount = doc.internal.getNumberOfPages()

    doc.setFont("helvetica", "italic")
    doc.setFontSize(8)

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.text(
        "Page " + String(i) + " of " + String(pageCount),
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 10,
        {
          align: "center",
        },
      )
    }
  }

  const handleHuddleSummaryDownload = () => {
    const doc = new jsPDF() as any
    let currentY = 50

    addHeaders(doc, "Huddle Summary")

    doc.setFontSize(14)
    doc.text(
      "Huddle Summary Today Goals",
      doc.internal.pageSize.width / 2,
      currentY,
      {
        align: "center",
      },
    )

    currentY += 5

    autoTable(doc, {
      html:
        assignTableId("daily-production-goal", "daily-production-goal-table") ||
        "",
      startY: currentY + 5,
      styles: {
        cellWidth: "auto",
        fontSize: 9,
      },
    })

    currentY = doc.lastAutoTable.finalY + 15

    doc.setFontSize(14)
    doc.text(
      "Huddle Summary Prior Day Goals",
      doc.internal.pageSize.width / 2,
      currentY,
      {
        align: "center",
      },
    )

    currentY += 5

    // let huddleSummaryYesterdayTableHeaders
    // let huddleSummaryYesterdayTableData
    // if (
    //   huddleSummaryData?.huddleSummaryYesterdayTableData &&
    //   huddleSummaryData?.huddleSummaryYesterdayTableData.length > 0
    // ) {
    //   ;({
    //     headers: huddleSummaryYesterdayTableHeaders,
    //     dataArray: huddleSummaryYesterdayTableData,
    //   } = extractTableData(
    //     huddleSummaryYesterdayColumns,
    //     huddleSummaryData?.huddleSummaryYesterdayTableData,
    //   ))
    // }

    autoTable(doc, {
      html:
        assignTableId(
          "huddle-summary-yesterday",
          "huddle-summary-yesterday-table",
        ) || "",
      startY: currentY + 5, // Increase startY for spacing
    })

    currentY = doc.lastAutoTable.finalY + 15 // Update currentY position

    // Future Table

    doc.setFontSize(14)
    doc.text(
      "Huddle Summary Future Goals",
      doc.internal.pageSize.width / 2,
      currentY,
      {
        align: "center",
      },
    )
    currentY += 5

    autoTable(doc, {
      html:
        assignTableId("huddle-summary-future", "huddle-summary-future-table") ||
        "",
      startY: currentY + 5, // Increase startY for spacing
    })

    currentY = doc.lastAutoTable.finalY + 15

    // Key Metrics Table

    doc.setFontSize(14)
    doc.text(
      "Huddle Summary Key Metrics",
      doc.internal.pageSize.width / 2,
      currentY,
      {
        align: "center",
      },
    )

    currentY += 5

    autoTable(doc, {
      html:
        assignTableId(
          "huddle-summary-key-metrics",
          "huddle-summary-key-metrics-table",
        ) || "",
      startY: currentY + 5,
    })

    // Footer
    addFooters(doc)

    doc.save(`huddle_summary.pdf`)
  }

  const handleHuddleSummaryDownloadCSV = () => {
    const config1 = mkConfig(
      csvConfig("Huddle_Summary_Today_Goals", "Huddle Summary Today Goals"),
    )

    const csvData1 = generateCsv(config1)(
      transformDataCSV(
        dailyProductionGoalColumns,
        huddleSummaryData?.huddleSummaryTodayTableData || [],
      ),
    )
    download(config1)(csvData1)

    const config2 = mkConfig(
      csvConfig(
        "Huddle_Summary_Prior_Day_Goals",
        "Huddle Summary Prior Day Goals",
      ),
    )

    const csvData2 = generateCsv(config2)(
      transformDataCSV(
        huddleSummaryYesterdayColumns,
        huddleSummaryData?.huddleSummaryYesterdayTableData || [],
      ),
    )
    download(config2)(csvData2)

    const config3 = mkConfig(
      csvConfig("Huddle_Summary_Future_Goals", "Huddle Summary Future Goals"),
    )

    const csvData3 = generateCsv(config3)(
      transformDataCSV(
        huddleSummaryFutureColumns,
        huddleSummaryData?.huddleSummaryFutureTableData || [],
      ),
    )
    download(config3)(csvData3)

    const config4 = mkConfig(
      csvConfig("Huddle_Summary_Key_Metrics", "Huddle Summary Key Metrics"),
    )

    const csvData4 = generateCsv(config4)(
      transformDataCSV(
        huddleSummaryKeyMetricColumns,
        huddleSummaryKeyMetricsData || [],
      ),
    )
    download(config4)(csvData4)
  }

  const handleActiveOpportunitiesDownload = () => {
    const doc = new jsPDF()

    addHeaders(doc, "Huddle Active Opportunities")
    let huddleActiveOpportunitiesTableData: any = []
    let huddleActiveOpportunitiesTableHeaders: any = []

    if (
      huddleActiveOpportuntiesData &&
      huddleActiveOpportuntiesData.length > 0
    ) {
      ;({
        headers: huddleActiveOpportunitiesTableHeaders,
        dataArray: huddleActiveOpportunitiesTableData,
      } = extractTableData(
        activeOpportuntiesColumns,
        huddleActiveOpportuntiesData || [],
      ))
    }
    autoTable(doc, {
      html:
        assignTableId(
          "huddle-active-opportunities",
          "huddle-active-opportunities-table",
        ) || "",
      startY: 45,
    })

    // Footer

    addFooters(doc)

    doc.save(`huddle_active_opportunities.pdf`)
  }

  const handleActiveOpportunitiesDownloadCSV = () => {
    const config = mkConfig(
      csvConfig("Huddle_Active_Opportunities", "Huddle Active Opportunities"),
    )

    const csvData = generateCsv(config)(
      transformDataCSV(
        activeOpportuntiesColumns,
        huddleActiveOpportuntiesData || [],
      ),
    )
    download(config)(csvData)
  }

  const handleProviderSummaryDownload = () => {
    const doc = new jsPDF("landscape")

    addHeaders(doc, "Provider Summary")

    autoTable(doc, {
      html: assignTableId("provider-summary", "provider-summary-table") || "",
      startY: 45,
    })

    // Footer

    addFooters(doc)

    doc.save(`provider_summary.pdf`)
  }

  const handleProviderSummaryDownloadCSV = () => {
    const config = mkConfig(csvConfig("Provider_Summary", "Provider Summary"))

    const csvData = generateCsv(config)(
      transformDataCSV(providerSummaryColumns, providerSummaryData || []),
    )
    download(config)(csvData)
  }

  const handlePatientAuditSummaryDownload = () => {
    const doc = new jsPDF("landscape") as any
    let currentY = 50 // Initial Y position

    addHeaders(
      doc,
      `Patient Audit Summary | ${
        valueTab === "1"
          ? "Tomorrow"
          : valueTab === "2"
          ? "Today"
          : valueTab === "3"
          ? "Prior Day"
          : valueTab === "4"
          ? "Compliance"
          : ""
      } `,
    )
    switch (valueTab) {
      case "1":
        let tomorrowsAuditTableData = []
        let tomorrowsAuditTableHeaders = []

        if (huddleTomorrowAuditData) {
          ;({
            headers: tomorrowsAuditTableHeaders,
            dataArray: tomorrowsAuditTableData,
          } = extractTableData(
            todayAuditColumns,
            huddleTomorrowAuditData?.patient_list || [],
          ))
        }

        autoTable(doc, {
          head: [tomorrowsAuditTableHeaders],
          body: tomorrowsAuditTableData,
          didParseCell: function (data) {
            if (
              data.cell.raw === "True" ||
              data.cell.raw === "-" ||
              data.cell.raw === "False"
            ) {
              data.cell.text = [""]
            }
          },
          didDrawCell: function (data) {
            if (
              data.section === "body" &&
              data.column.index >= 3 &&
              data.column.index <= 10
            ) {
              const cellValue = data.cell.raw
              const { cell } = data
              if (cellValue === "True") {
                doc.setFillColor(255, 0, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              } else {
                doc.setFillColor(0, 128, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              }
            }
          },
          startY: 45,
        })

        addFooters(doc)
        doc.save(`patient_audit_summary_tomorrow.pdf`)
        break
      case "2":
        let todaysAuditTableData = []
        let todaysAuditTableHeaders = []

        if (huddleTodayAuditData) {
          ;({
            headers: todaysAuditTableHeaders,
            dataArray: todaysAuditTableData,
          } = extractTableData(
            todayAuditColumns,
            huddleTodayAuditData?.patient_list || [],
          ))
        }

        autoTable(doc, {
          head: [todaysAuditTableHeaders],
          body: todaysAuditTableData,
          didParseCell: function (data) {
            if (
              data.cell.raw === "True" ||
              data.cell.raw === "-" ||
              data.cell.raw === "False"
            ) {
              data.cell.text = [""]
            }
          },
          didDrawCell: function (data) {
            if (
              data.section === "body" &&
              data.column.index >= 3 &&
              data.column.index <= 10
            ) {
              const cellValue = data.cell.raw
              const { cell } = data
              if (cellValue === "True") {
                doc.setFillColor(255, 0, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              } else {
                doc.setFillColor(0, 128, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              }
            }
          },
          startY: 45,
        })
        addFooters(doc)
        doc.save(`patient_audit_summary_today.pdf`)
        break
      case "3":
        let priorsDaysAuditTableData = []
        let priorsDaysAuditTableHeaders = []

        if (huddleYesterdayAuditData) {
          ;({
            headers: priorsDaysAuditTableHeaders,
            dataArray: priorsDaysAuditTableData,
          } = extractTableData(
            yesterdayAuditColumns,
            huddleYesterdayAuditData?.patient_list || [],
          ))
        }

        autoTable(doc, {
          head: [priorsDaysAuditTableHeaders],
          body: priorsDaysAuditTableData,
          didParseCell: function (data) {
            if (
              data.cell.raw === "True" ||
              data.cell.raw === "-" ||
              data.cell.raw === "False"
            ) {
              data.cell.text = [""]
            }
          },
          didDrawCell: function (data) {
            if (
              data.section === "body" &&
              data.column.index >= 2 &&
              data.column.index <= 9
            ) {
              const cellValue = data.cell.raw
              const { cell } = data
              if (cellValue === "True") {
                doc.setFillColor(255, 0, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              } else {
                doc.setFillColor(0, 128, 0)
                doc.circle(
                  cell.x + cell.width / 2,
                  cell.y + cell.height / 2,
                  2,
                  "F",
                )
              }
            }
          },
          startY: 45,
        })
        addFooters(doc)
        doc.save(`patient_audit_summary_prior_day.pdf`)
        break
      case "4":
        autoTable(doc, {
          html: assignTableId("PDS-compliance", "PDS-compliance-table") || "",
          startY: 45, // Adjust startY based on currentY position
        })
        addFooters(doc)
        doc.save(`patient_audit_summary_compliance.pdf`)
        break
      default:
        break
    }
  }

  const handlePatientAuditSummaryDownloadCSV = () => {
    switch (valueTab) {
      case "1": {
        const config = mkConfig(
          csvConfig("Patient_Audit_Summary_Tomorrow", "Tomorrow's Audit"),
        )
        const csvData = generateCsv(config)(
          transformDataCSV(
            todayAuditColumns,
            huddleTomorrowAuditData?.patient_list || [],
          ),
        )
        download(config)(csvData)
        break
      }
      case "2": {
        const config = mkConfig(
          csvConfig("Patient_Audit_Summary_Today", "Today's Audit"),
        )
        const csvData = generateCsv(config)(
          transformDataCSV(
            todayAuditColumns,
            huddleTodayAuditData?.patient_list || [],
          ),
        )
        download(config)(csvData)
        break
      }
      case "3": {
        const config = mkConfig(
          csvConfig("Patient_Audit_Summary_Prior_Day", "Prior Days Audit"),
        )
        const csvData = generateCsv(config)(
          transformDataCSV(
            yesterdayAuditColumns,
            huddleYesterdayAuditData?.patient_list || [],
          ),
        )
        download(config)(csvData)
        break
      }
      case "4": {
        const config = mkConfig(
          csvConfig("Patient_Audit_Summary_Compliance", "Compliance"),
        )
        const csvData = generateCsv(config)(
          transformDataCSV(columns, data || []),
        )
        download(config)(csvData)
        break
      }
      default:
        break
    }
  }

  const enableEditing = React.useMemo(() => {
    return perms?.includes(permissions.EDIT_YESTERDAY_HOURS)
  }, [perms])
  const fetchByHuddleTabId = (tab: any) => {
    switch (tab?.id) {
      case "huddle_summary": {
        dispatch(setSelectedHuddleTab(tab))
        break
      }
      case "active_opportunities": {
        dispatch(setSelectedHuddleTab(tab))
        break
      }
      case "provider_summary": {
        dispatch(setSelectedHuddleTab(tab))
        break
      }
      case "patient_audit_summary": {
        dispatch(setSelectedHuddleTab(tab))
        break
      }
    }
  }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#F8F9FA",
        }}
      >
        <HuddleHeader
          name="Huddle"
          handleDownload={
            downloadSelection === "PDF"
              ? selectedHuddleTab?.id == "huddle_summary"
                ? handleHuddleSummaryDownload
                : selectedHuddleTab?.id == "active_opportunities"
                ? handleActiveOpportunitiesDownload
                : selectedHuddleTab?.id == "provider_summary"
                ? handleProviderSummaryDownload
                : handlePatientAuditSummaryDownload
              : downloadSelection === "CSV"
              ? selectedHuddleTab?.id == "huddle_summary"
                ? handleHuddleSummaryDownloadCSV
                : selectedHuddleTab?.id == "active_opportunities"
                ? handleActiveOpportunitiesDownloadCSV
                : selectedHuddleTab?.id == "provider_summary"
                ? handleProviderSummaryDownloadCSV
                : handlePatientAuditSummaryDownloadCSV
              : null
          }
          rows={huddleSummaryTodayRows}
        />
        {selectedHuddleOffice ? (
          <>
            <Box sx={{ padding: "0 25px" }}>
              <HuddleTabs fetchByHuddleTabId={fetchByHuddleTabId} />
            </Box>
            {selectedHuddleTab?.id == "huddle_summary" ? (
              <Box
                sx={{
                  padding: "10px 0px",
                  height: "70vh",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  margin: "0 24px",
                }}
              >
                <TableWrapperPaper
                  sx={{ mb: "5px", width: "90vw" }}
                  id="daily-production-goal"
                >
                  <Box sx={{ display: "flex" }}>
                    <Typography
                      sx={{
                        pl: "25px",
                        py: "8px",
                        fontWeight: "bold",
                        flex: 1,
                      }}
                    >
                      {`Daily Production Goal - ${
                        huddleSummaryData?.dailyProductionGoalValue
                          ? roundUp(
                              huddleSummaryData?.dailyProductionGoalValue,
                              "$",
                              0,
                            )
                          : "N/A"
                      }`}
                    </Typography>
                    <Typography
                      sx={{
                        pl: "25px",
                        py: "8px",
                        fontWeight: "bold",
                        flex: 1,
                        borderLeft: "1px solid #ACAAAD",
                      }}
                    >
                      {`Daily Collection Goal - ${
                        huddleSummaryData?.dailyCollectionGoalValue
                          ? roundUp(
                              huddleSummaryData?.dailyCollectionGoalValue,
                              "$",
                              0,
                            )
                          : "N/A"
                      }`}
                    </Typography>
                  </Box>

                  <DailyProductionGoalTable
                    flex={false}
                    columns={dailyProductionGoalColumns}
                    data={huddleSummaryData?.huddleSummaryTodayTableData || []}
                    // data={[]}
                  />
                </TableWrapperPaper>

                <Box
                  sx={{
                    display: "flex",
                    height: "fit-content",
                    width: "90vw",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "fit-content",
                      width: "45vw",
                      flex: 1,
                    }}
                  >
                    <TableWrapperPaper
                      sx={{ mb: "5px" }}
                      id="huddle-summary-yesterday"
                    >
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          sx={{ pl: "25px", py: "8px", fontWeight: "bold" }}
                        >
                          {`Prior Day`}
                        </Typography>
                      </Box>
                      <HuddleSummaryYesterdayTable
                        columns={huddleSummaryYesterdayColumns}
                        data={
                          huddleSummaryData?.huddleSummaryYesterdayTableData ||
                          []
                        }
                      />
                    </TableWrapperPaper>

                    <TableWrapperPaper id="huddle-summary-future">
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          sx={{ pl: "25px", py: "8px", fontWeight: "bold" }}
                        >
                          {`Future`}
                        </Typography>
                      </Box>
                      <HuddleSummaryFutureTable
                        columns={huddleSummaryFutureColumns}
                        data={
                          huddleSummaryData?.huddleSummaryFutureTableData || []
                        }
                      />
                    </TableWrapperPaper>
                  </Box>
                  <TableWrapperPaper
                    sx={{ flex: 1, marginLeft: "8px" }}
                    id="huddle-summary-key-metrics"
                  >
                    <Box sx={{ display: "flex" }}>
                      <Typography
                        sx={{ pl: "25px", py: "8px", fontWeight: "bold" }}
                      >
                        {`Key Metrics`}
                      </Typography>
                    </Box>
                    <HuddleSummaryKeyMetricsTable
                      columns={huddleSummaryKeyMetricColumns}
                      data={huddleSummaryKeyMetricsData || []}
                    />
                  </TableWrapperPaper>
                </Box>
              </Box>
            ) : selectedHuddleTab?.id == "active_opportunities" ? (
              <Box
                sx={{
                  padding: "10px 0px",
                  height: "70vh",
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <TableWrapperPaperOld
                  sx={{ marginX: "24px" }}
                  id="huddle-active-opportunities"
                >
                  <ActiveOpportunitiesTable
                    columns={activeOpportuntiesColumns}
                    data={huddleActiveOpportuntiesData || []}
                  />
                </TableWrapperPaperOld>
              </Box>
            ) : selectedHuddleTab?.id == "provider_summary" ? (
              <Box
                sx={{
                  padding: "0px 24px",
                  height: "70vh",
                  marginTop: "10px",
                  display: "flex",
                  width: "100%",
                }}
              >
                {/* <ScrollSyncPane>
                          <TableWrapperPaper sx={{ overflow: "auto" }}>
                          <Box sx={{ display: "flex" }}>
                          <Typography sx={{ pl: "25px", py: "8px", fontWeight: "bold", flex: 1, color: "#FFFFFF" }}>
                          {`Y`}
                          </Typography>
                          </Box>
                          
                          <ProviderSummaryFixTable
                          columns={providerSummaryFixedColumns}
                          data={providerSummaryData || []}
                          enableEditing={true}
                          blurHandler={openDialog}
                          // data={[]}
                          />
                          </TableWrapperPaper>
                        </ScrollSyncPane> */}
                <TableWrapperPaper id="provider-summary">
                  {/* <Box sx={{ display: "flex", overflow: "auto", width: "90vw" }}>
                          <Typography sx={{ pl: "25px", py: "8px", fontWeight: "bold", marginLeft: "180px", borderLeft: "1px solid #ACAAAD", flex: 3 }}>
                            {`Yesterday`}
                          </Typography>
                          <Typography sx={{ pl: "25px", py: "8px", fontWeight: "bold", borderLeft: "1px solid #ACAAAD", flex: 3 }}>
                            {`Today`}
                          </Typography>
                          <Typography sx={{ pl: "25px", py: "8px", fontWeight: "bold", borderLeft: "1px solid #ACAAAD", flex: 4 }}>
                            {`Variance (Next 5 days)`}
                          </Typography>
                        </Box> */}
                  <ProviderSummaryTable
                    columns={providerSummaryColumns}
                    data={providerSummaryData || []}
                    enableEditing={true}
                    blurHandler={openDialog}
                    // data={[]}
                  />
                </TableWrapperPaper>
              </Box>
            ) : (
              <Box sx={{ margin: "0px 24px" }}>
                <TabContext value={valueTab}>
                  <StyledTabsList
                    aria-label="UMTabs"
                    onChange={handleChangeTab}
                  >
                    <Tab label="Tomorrow's Audit" value="1" disableRipple />
                    <Tab label="Today's Audit" value="2" disableRipple />
                    <Tab label="Prior Day's Audit" value="3" disableRipple />
                    <Tab label="Compliance" value="4" disableRipple />
                  </StyledTabsList>
                  <TabPanel value="1" sx={{ height: "60vh", padding: 0 }}>
                    <Box
                      id="PDS-tomorrows-audit"
                      sx={{
                        padding: "10px 0px",
                        height: "60vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <TableWrapperPaperOld>
                        <AuditTable
                          columns={todayAuditColumns}
                          data={huddleTomorrowAuditData?.patient_list || []}
                          pinningCols={["patient_name"]}
                        />
                      </TableWrapperPaperOld>
                    </Box>
                  </TabPanel>
                  <TabPanel value="2" sx={{ height: "60vh", padding: 0 }}>
                    <Box
                      id="PDS-todays-audit"
                      sx={{
                        padding: "10px 0px",
                        height: "60vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <TableWrapperPaperOld>
                        <AuditTable
                          columns={todayAuditColumns}
                          data={huddleTodayAuditData?.patient_list || []}
                          pinningCols={["patient_name"]}
                        />
                      </TableWrapperPaperOld>
                    </Box>
                  </TabPanel>
                  <TabPanel value="3" sx={{ height: "60vh", padding: 0 }}>
                    <Box
                      id="PDS-yesterday-audit"
                      sx={{
                        padding: "10px 0px",
                        height: "60vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <TableWrapperPaperOld>
                        <AuditTable
                          columns={yesterdayAuditColumns}
                          data={huddleYesterdayAuditData?.patient_list || []}
                          pinningCols={["patient_name"]}
                        />
                      </TableWrapperPaperOld>
                    </Box>
                  </TabPanel>
                  <TabPanel value="4" sx={{ height: "60vh", padding: 0 }}>
                    <Box
                      id="PDS-compliance"
                      sx={{
                        padding: "10px 0px",
                        height: "60vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <TableWrapperPaperOld>
                        <AuditTable
                          columns={columns}
                          data={data}
                          pinningCols={["type"]}
                          containderStyles={{ borderRadius: "4px" }}
                        />
                      </TableWrapperPaperOld>
                    </Box>
                  </TabPanel>
                </TabContext>
              </Box>
            )}
          </>
        ) : (
          <NavigationAssistant
            data={navigationData}
            // selectedgroup={selectedHuddleGroup}
            // selecetedregion={selectedHuddleRegion}
          />
        )}
      </Box>
      <ConfirmModal
        close={closeDialog}
        open={editState.showDialog}
        confirmActionHandler={confirmActionHandler}
        title={"Confirm Hours change"}
        optionalMessage={
          <Typography sx={{ fontSize: "14px", lineHeight: 2 }}>
            Are you sure you want to change hours for provider
            <br />
            <b style={{ color: "#000" }}>
              {" "}
              " {editState.provider || "seleced"} "
            </b>
          </Typography>
        }
        confirmButtonText={"Confirm"}
        cancelButtonText={"Cancel"}
        api={{ loading: editState.loading }}
      />
    </>
  )
}

export default Huddle
